angular
	.module 'App.Repository'
	.factory 'VatRateOverrideGroupRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class VatRateOverrideGroupRepository extends BaseRepository
				@resource = '/vat_rate_override_groups'
				@isRestricted = true

			return new VatRateOverrideGroupRepository
	]
